<script lang="ts">
  import { fade } from 'svelte/transition';
  import { api } from '$lib/api';
  import { DATA_PRIVACY_URL, TERMS_AND_CONDITIONS_URL } from '$/lib/globals';
  import Spinner from '$lib/components/Spinner.svelte';
  let email = '';
  let name: string = '';
  let isSubmitting = false;
  let signupError: null | string = null;
  let signupSuccess = false;
  let consentCheckbox = false;

  async function signUp() {
    signupError = '';
    isSubmitting = false;
    signupError = null;
    signupSuccess = false;

    if (!email) {
      signupError = 'Please provide an email.';
      return;
    }

    isSubmitting = true;

    const isNameEmpty = name.trim() === '';
    const payloadName = isNameEmpty ? undefined : name;

    try {
      await api('/password/signup').call({
        method: 'post',
        json: { email, name: payloadName },
      });

      signupSuccess = true;
    } catch (err) {
      signupError = 'Unknown error, please try again.';
    } finally {
      isSubmitting = false;
    }
  }
</script>

<div class="mb-2 text-center font-causten text-3xl font-bold text-black">
  Create your account
</div>

<div class="mb-3 font-normal text-black">
  We are going to send you a link to set your password.
</div>

{#if signupError}
  <p class="-mt-1 mb-4 text-center text-red-600">{signupError}</p>
{:else if signupSuccess}
  <div class=" pome-alert bg-pome-alert-success p-3">
    The email was sent successfully!<br />
    <span class="text-sm">Check your spam folder</span>
  </div>
{/if}
{#if !signupSuccess}
  <form in:fade on:submit|preventDefault={signUp}>
    <label>
      <span class="font-bold text-black"
        >Name <span class="text-sm font-normal">(optional)</span></span
      >
      <input
        type="text"
        title="Name"
        bind:value={name}
        placeholder="Ernest Hemingway"
        class="default-text-input mb-3 mt-1 w-full"
      />
    </label>
    <label>
      <span class="font-bold text-black">Email</span>
      <input
        type="email"
        title="Your email should be an Orrick email address"
        placeholder="ehemingway@orrick.com"
        class="default-text-input mb-4 mt-1 w-full"
        bind:value={email}
        autocomplete="username"
        pattern=".+@orrick\.com"
        required
      />
    </label>

    <div class="mb-3">
      <label class="cursor-pointer">
        <input
          class="default-checkbox"
          type="checkbox"
          bind:checked={consentCheckbox}
        />
        <span class="pl-1 font-normal text-black"
          >I have read and I agree to Pome's <a
            class="normal-link-light-bg"
            href={TERMS_AND_CONDITIONS_URL}
            target="_blank"
            rel="noreferrer">terms & conditions</a
          >
          and
          <a
            class="normal-link-light-bg"
            href={DATA_PRIVACY_URL}
            target="_blank"
            rel="noreferrer">data privacy notice</a
          ></span
        >
      </label>
    </div>

    <button
      class="btn btn-primary flex w-full items-center justify-center"
      type="submit"
      disabled={isSubmitting || !consentCheckbox}
      >{#if !isSubmitting}Sign Up{:else}<Spinner />{/if}</button
    >
  </form>
  <div class="-mb-3 mt-2 text-left">
    <a href="/auth/login" class="normal-link-light-bg cursor-pointer text-sm">
      Already have an account?
    </a>
  </div>
{/if}
